import React, { useRef, useState, useCallback } from 'react';
import Webcam from 'react-webcam';

const videoConstraints = {
  width: 540,
  facingMode: 'environment',
};

const Camera = () => {
  const webcamRef = useRef(null);
  const [url, setUrl] = useState(null);
  const capturePhoto = useCallback(async () => {
    // console.log("clicked");
    const imageSource = webcamRef.current.getScreenshot();
    setUrl(imageSource);
  }, [webcamRef]);

  const submitPhoto = () => {
    // console.log(url);
    // id++;
    // localStorage.setItem(id,JSON.stringify(url));
    // Uploading the image
    // import React, {useState} from "react";
    // import library to make http req; (axios is one such)
    /* base64 encoded image string
    const image=props.image64;
    // url used for API calls
    const reqUrl="temp";
    // making post req using http library
    const postImage = (newImage) => httplibrary.post(reqUrl, newImage);

    // TO Catch any exception while post req
    const createPost = async (image64) => {
        try{
            await postImage(image64);
        } catch (error){
            console.log(error.message);
        }
    };
    createPost(image);
    */
  };
  /* const onUserMedia = (e) => {
    console.log(e);
  }; */
  const fieldId = 'cam_buttons';
  const fieldLabel = {
    // label: 'Temp',
    cssProperties: {
      style: 'btn btn-block margin-3-tb margin-auto-lr',
    },
  };
  /* const cssProperties = {
    style: 'col-md-10 col-md-offset-1 pad-1-lr',
  }; */

  return (
    <div>
      <div>
        {!url && (
          <div>
            <div>
              <Webcam
                ref={webcamRef}
                audio={false}
                screenshotFormat="image/png"
                videoConstraints={videoConstraints}
                // onUserMedia={onUserMedia}
                mirrored={true}
              />
            </div>
            <button
              type="submit"
              className={`${fieldLabel.cssProperties.style} ${fieldId}`}
              onClick={capturePhoto}
            >
              Capture
            </button>
          </div>
        )}
      </div>
      <div>
        {url && (
          <div>
            <div>
              <img src={url} alt="Screenshot" />
            </div>
            <button
              type="submit"
              className={`${fieldLabel.cssProperties.style} ${fieldId}`}
              onClick={() => setUrl(null)}
            >
              Retake
            </button>
            <button
              type="submit"
              className={`${fieldLabel.cssProperties.style} ${fieldId}`}
              onClick={submitPhoto}
            >
              Submit
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default Camera;
